// frontend/src/components/dialogs/DeleteConfirmDialog.js

import { Trash2, X } from 'lucide-react';
import { useTranslation } from 'react-i18next';
import { useTheme } from '../../contexts/ThemeContext';
import ConfirmDialogShell from './ConfirmDialogShell';

const DeleteConfirmDialog = ({
    isOpen,
    onClose,
    onConfirm,
    isDeleting = false,
    title,
    message
}) => {
    const { t } = useTranslation();
    const { text, cn } = useTheme();

    // Default values with translation support
    const dialogTitle = title || t('Confirm Delete');
    const dialogMessage = message || t('areYouSure');

    return (
        <ConfirmDialogShell
            isOpen={isOpen}
            onClose={onClose}
            onConfirm={onConfirm}
            title={dialogTitle}
            confirmLabel={t('Confirm')}
            cancelLabel={t('Cancel')}
            confirmVariant="danger"
            confirmIcon={Trash2}
            cancelIcon={X}
            isLoading={isDeleting}
            showIcon={true}
            iconVariant="danger"
            size="md"
        >
            <p className={cn('text-center', text.secondary)}>
                {dialogMessage}
            </p>
        </ConfirmDialogShell>
    );
};

export default DeleteConfirmDialog;